import { sessionTrackStatus } from '@racedash/shared'
import type { TrackStatus as Status } from '@racedash/shared'
import { Datum, Tile } from '../Tile'
import type { WidgetProps } from './props'

/**
 * How a vendor's track state maps onto the one tile allowed to use colour.
 *
 * A full course yellow and a safety car share a tone because they mean the same
 * thing to a driver — the field is neutralised — while keeping their own
 * labels, because they do not mean the same thing to a strategist.
 */
const tones: Record<Status, 'green' | 'yellow' | 'red' | 'finished' | undefined> = {
  green: 'green',
  yellow: 'yellow',
  fcy: 'yellow',
  safetyCar: 'yellow',
  red: 'red',
  finished: 'finished',
  unknown: undefined,
}

export default function TrackStatus({ data }: WidgetProps<'trackStatus'>) {
  // A finished session reads Finished, whatever colour the vendor left on
  // the board. See sessionTrackStatus.
  const state = sessionTrackStatus(data.session)

  return (
    <Tile label="Track" tone={tones[state.status]}>
      <Datum value={state.label} as="text" />
    </Tile>
  )
}
